import { render } from "./ThaiAddressFields.vue?vue&type=template&id=22b4dca3&scoped=true"
import script from "./ThaiAddressFields.vue?vue&type=script&lang=js"
export * from "./ThaiAddressFields.vue?vue&type=script&lang=js"

import "./ThaiAddressFields.vue?vue&type=style&index=0&id=22b4dca3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b4dca3"]])

export default __exports__